/* eslint-disable no-unused-vars */
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import UpcomingPage from "./UpcomingPage/UpcomingPage";
import VehiclesPage from "./FleetManagementPage/VehiclesTab/VehiclesPage";
import DriversPage from "./FleetManagementPage/DriversTab/DriversPage";
import EquipmentPage from "./FleetManagementPage/EquipmentTab/EquipmentPage";
import RentalsPage from "./RentalsPage/RentalsPage";
import AnalyticsPage from "./AnalyticsPage/Loader";
import InsightsPage from "./InsightsPage/Loader";
import InsightsSettingsPage from "./InsightsPage/settings/Loader";
import FeatureToggle from "../Components/FeatureToggle";
import SettingsPage from "./SettingsPage";
import UserAccountPage from "./UserAccountPage";
import ConsolidatedInvoicingPage from "./ConsolidatedInvoicePage";
import OutgoingInvoicePage from "./OutgoingInvoicePage";
import DispatchPage from "./DispatchPage/loader";
import EmissionsPage from "./EmissionsPage/Loader";
import CargosReportPage from "./CargosReportPage/Loader";
import InvoicingPage from "./InvoicingPage/Loader";
import TrackerDevicesPage from "./FleetManagementPage/TrackerDevicesTab/TrackerDevicesPage";
// import TrackerDevicesPage from "../Components/fleet-management/TrackerDevicesPage";
import VehiclePage from "./VehiclePage";
import OnboardingVideosPage from "./OnboardingVideosPage";
import NewsVideosPage from "./NewsVideosPage";
import LiveViewPages from "./LiveViewPage";
import { useFeature } from "../hooks";
import LiteVersionSingleRoute from "./LightVersionSingleRoute/LiteVersionSingleRoute";
import MapTestPage from "./TestPages/MapTestPage";
import ReferralModalPage from "../Components/nav/ReferralModalPage";

const AuthenticatedRoutes = () => {
  const liteVersion = useFeature("lite-version");
  const referralEnabled = useFeature("referral-link");
  const insightsEnabled = useFeature("insights");
  const invoicingUxEnabled = useFeature("invoicing-ux");
  const location = useLocation();
  const state = location.state as { backgroundLocation?: Location };
  const backgroundLocation = state?.backgroundLocation || null;

  return (
    <>
      <Routes location={backgroundLocation || location}>
        {!liteVersion && (
          <>
            <Route path="/dispatching/*" element={<DispatchPage />} />
            <Route
              path="/finance/outgoing-invoices/:id"
              element={<OutgoingInvoicePage />}
            />
            <Route
              path="/fleet/vehicles/:vehicleId"
              element={<VehiclePage />}
            />
            <Route path="/upcoming" element={<UpcomingPage />} />
            <Route path="/live-view/*" element={<LiveViewPages />} />
            <Route path="/user-account" element={<UserAccountPage />} />
            <Route path="/drivers" element={<DriversPage />} />
            <Route path="/equipment" element={<EquipmentPage />} />
            <Route path="/rentals" element={<RentalsPage />} />
            <Route path="/tracker-devices" element={<TrackerDevicesPage />} />
            <Route path="/maptest" element={<MapTestPage />} />
            {invoicingUxEnabled && (
              <>
                <Route path="/invoicing" element={<InvoicingPage />} />
                <Route path="/invoicing/:tab" element={<InvoicingPage />} />
              </>
            )}
            <Route
              path="/consolidated-invoicing"
              element={<ConsolidatedInvoicingPage />}
            />
            <Route
              path="/analytics"
              element={
                <FeatureToggle feature="analytics">
                  <AnalyticsPage />
                </FeatureToggle>
              }
            />
            {insightsEnabled && (
              <Route path="/insights" element={<InsightsPage />} />
            )}
            {insightsEnabled && (
              <Route
                path="/insights/settings"
                element={<InsightsSettingsPage />}
              />
            )}
            {referralEnabled && (
              <Route
                path="/referral"
                element={<ReferralModalPage fullPage={!backgroundLocation} />}
              />
            )}
            <Route path="*" element={<Navigate to="/dispatching" />} />
          </>
        )}
        {liteVersion && (
          <>
            <Route path="*" element={<Navigate to="/add" />} />
            <Route path="/add" element={<LiteVersionSingleRoute />} />
          </>
        )}
        <Route path="/settings/*" element={<SettingsPage />} />
        <Route path="/fleet" element={<VehiclesPage />} />
        <Route path="/help-and-support" element={<OnboardingVideosPage />} />
        <Route path="/news" element={<NewsVideosPage />} />

        <Route path="/emissions" element={<EmissionsPage />} />
        <Route path="/cargos-report" element={<CargosReportPage />} />
      </Routes>
      {referralEnabled && backgroundLocation && (
        <Routes>
          <Route path="/referral" element={<ReferralModalPage />} />
        </Routes>
      )}
    </>
  );
};

export default AuthenticatedRoutes;
